import { useMemo } from 'react'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import Flags from 'country-flag-icons/react/1x1'
import flagStyles from '@/styles/FlagIcon.module.scss'

type Props = {
  transaction?: TransactionType
}

const useFlagIcon = (props : Props) => {
  const transaction = props?.transaction
  const getFlagComponent = (flagCode) => {
    const Flag = Flags[flagCode]
    if (Flag) {
      return (
        <span className={`${flagStyles['board-flag-container']}`}>
          <Flag style={{ width: 14, height: 14 }} />
        </span>
      )
    }
    return null
  }

  const pickupFlag = useMemo(() => {
    const countryCode = transaction?.pickupRoute?.countryCode
    return countryCode ? getFlagComponent(countryCode) : <></>
  }, [transaction?.pickupRoute?.countryCode])

  const deliveryFlag = useMemo(() => {
    const countryCode = transaction?.deliveryRoute?.countryCode
    return countryCode ? getFlagComponent(countryCode) : <></>
  }, [transaction?.deliveryRoute?.countryCode])

  return {
    pickupFlag,
    deliveryFlag,
    getFlagComponent
  }
}

export default useFlagIcon
